import { MetaData } from '@/models/dtos';
import { Constants } from '@/const';
export default {
	/**
	 * Returns vue-meta array from meta object.
	 * @param meta The meta object
	 * @returns {Array} An array with meta data for use with vue-meta
	 */
	getMetaDataArrayFromMetaObject(meta: MetaData): any[] {
		const metaArray = [];
		metaArray.push({property: 'og:title', content: meta.ogTitle});
		metaArray.push({property: 'og:description', content: meta.ogDescription});
		metaArray.push({property: 'og:image', content: meta.ogImage});
		metaArray.push({property: 'og:url', content: (() => location.origin + location.pathname)()});
		metaArray.push({property: 'og:type', content: 'website'});
		metaArray.push({name: 'description', content: meta.description});
		return metaArray;
	},

	/**
	 * Gets the whole url based on relative url.
	 * @param relativeUrl
	 * @returns {string} Url
	 */
	getUrl(relativeUrl: string) {
		return `${Constants.apiBaseUrl}${relativeUrl}`;
	},
};
